export default "__VITE_ASSET__DWt9g54R__$_?component__"